import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppThemeProvider } from './themes/appThemeProvider';
import { ConfirmProvider } from 'material-ui-confirm';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './app';
import './main.css';
import './i18n';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppThemeProvider>
      <ConfirmProvider>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
          <App />
        </GoogleReCaptchaProvider>
      </ConfirmProvider>
    </AppThemeProvider>
  </React.StrictMode>,
);
